import http from "./axios/http";


export function getSportsInplayGames() {
  return http.post('/sports/inplay/games?t=' + new Date().getTime())
}
